module.exports = __webpack_public_path__ + "img/p3.62e0a2aa.png";